"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneObject = void 0;
const cloneObject = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};
exports.cloneObject = cloneObject;
